import { shallowEqual } from "react-redux";
import { selectTournamentIdsFromFilters } from "selectors/Tournament";
import { TrackLoader } from "pages/TrackLoader";
import { TracksPageContent } from "./TracksPageContent";
import { TracksFilters } from "components/FilterPanels/TracksFilters";
import {
  useYearFilter,
  useTourFilter,
  useSubTourFilter,
  useMultiTournamentFilter,
} from "model/Filter/TournamentFilters";
import { SingleColumnPage } from "pages/PageTemplates";
import { useAppSelector } from "app/hooks";

const INCLUDE_NON_TOUR_TOURNAMENTS = true;

export const TracksPage = () => {
  const yearFilter = useYearFilter(false);
  const selectedYear = yearFilter.selectedValue;
  const tourFilter = useTourFilter(
    selectedYear,
    undefined,
    INCLUDE_NON_TOUR_TOURNAMENTS,
    true
  );
  const selectedTour =
    tourFilter.selectedValue !== "All" ? tourFilter.selectedValue : undefined;
  const subTourFilter = useSubTourFilter(selectedTour, undefined, true);
  const selectedSubTour =
    subTourFilter.selectedValue !== "All"
      ? subTourFilter.selectedValue
      : undefined;
  const selectedSubTours = !!selectedSubTour ? [selectedSubTour] : undefined;
  const tournamentFilter = useMultiTournamentFilter(
    selectedYear,
    selectedTour,
    selectedSubTour,
    true
  );

  const tournamentIds = useAppSelector(
    (state) =>
      selectTournamentIdsFromFilters(
        state,
        selectedYear,
        selectedTour,
        selectedSubTours,
        tournamentFilter.selectedValues,
        INCLUDE_NON_TOUR_TOURNAMENTS
      ),
    shallowEqual
  );

  return (
    <SingleColumnPage>
      <TracksFilters
        yearFilter={yearFilter}
        tourFilter={tourFilter}
        subTourFilter={subTourFilter}
        tournamentFilter={tournamentFilter}
      />
      <TrackLoader tournamentIds={tournamentIds}>
        <TracksPageContent tournamentIds={tournamentIds} />
      </TrackLoader>
    </SingleColumnPage>
  );
};
